import {useStateValue} from 'state/index';
import {onException} from "state/httpStatusHandler";
import {success, error} from "@react/react-spectrum/Toast";
import {runUctScan} from "../queries";

const useUctScan = () => {
  const [state, dispatch] = useStateValue();
  return async (callback) => {
    await runUctScan()
      .then(() => {
        success("Scan in progress. May take 60 minutes or more to complete.", {timeout: 15000});
        callback();
      })
      .catch(errorObject => {
        if (errorObject.response?.status === 429) {
          const retryAfter = errorObject.response.data?.retry_after;
          const retryTime = retryAfter ? new Date(retryAfter).toLocaleString() : null;
          const message = retryTime
            ? `Scan rate limit exceeded. Please try again after ${retryTime}.`
            : 'Scan rate limit exceeded. Please try again later.';
          error(message, {timeout: 15000});
          return;
        }
        onException(errorObject, dispatch, state);
      });
  };
}

export default useUctScan;
